var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact row-container"},[_c('TitleBarOnlyText',{attrs:{"msg":_vm.msg}}),(_vm.$store.state.currentLanguage.id==0)?_c('ContactZh'):_c('ContactEn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }